import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=7bdde1e7&scoped=true&"
import script from "./Donate.vue?vue&type=script&lang=ts&"
export * from "./Donate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdde1e7",
  null
  
)

export default component.exports